module.exports = __webpack_public_path__ + "img/ReviewOrderDonutStatus.d930221b.png";